import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

export class CustomFieldMappings {
    Id: number;
    Name: string;
    ImportMappingJson: string;
}

@Injectable({
    providedIn: 'root',
})
export class CustomFieldsService {
    constructor(private http: HttpClient) {

    }

    private apiUrl = "/api/customfields";

    private handleError(error: any): Promise<any> {
        console.error("An error occurred", error);
        return Promise.reject(error.message || error);
    }

    getMappings(tenantId: string, moduleId: string) {
        const url = `${this.apiUrl}/getmappings/?tenantId=${tenantId}&moduleId=${moduleId}`;
        return this.http.get<CustomFieldMappings[]>(url);
    }

    updateMappings(customMapping: object) {
        const headers = new HttpHeaders({ "Content-Type": "application/json" });
        const options = { headers: headers };
        var obj = JSON.stringify(customMapping);
        return this.http.put<number>(`${this.apiUrl}`, obj, options);
    }
}
